export const ICON_TYPES = {
  CHECKMARK: 'checkmark',
  CLOSE: 'close'
};
